import { CommonModule, DOCUMENT, isPlatformBrowser } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  inject,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subscription, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { assetsConst } from "src/app/core/const/assets.const";
import { SearchModule } from "../search/search.module";
import { LoginComponent } from "src/app/modals/login/login.component";
import { ProfileDetails } from "src/app/models/authmodel";
import { AuthService } from "src/app/core/services/auth.service";
import { environment } from "src/environments/environment";
import { myDetailsDropDown } from "src/app/core/const/myDetailsDropDown.const";
import { logoutResponse } from "src/app/models/logoutResponse";
import { responseStatus } from "src/app/core/const/responseStatus.const";
import { HomeService } from "src/app/core/services/home.service";
import { fetchUserName } from "src/app/core/helpers/fetchUserName.helper";
import { generateRandomString } from "src/app/core/helpers/generateRandomString.helper";
import { Categories, HomeData } from "src/app/models/homeData";
import { SwalAlertService } from "src/app/core/services/swalAlert.service";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { globalSearchResponse } from "src/app/models/globalSearchResponse";
import { EncryptionService } from "src/app/core/services/encryption.service";
import { NoDataFoundComponent } from "../noDataFound/noDataFound.component";
import { GlobalSearchType } from "src/app/core/const/globalSearchType.const";
import { Brands, Products } from "src/app/models/products";
import { ProductType } from "src/app/core/const/productType.const";
import { PipesModule } from "../../pipes/pipes.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AddressCardComponent } from "../address-card/address-card.component";
import { ChangeAddressComponent } from "src/app/modals/change-address/change-address.component";
import { AddressPayload } from "src/app/models/addressPayload";
import { BagService } from "src/app/core/services/bag.service";
import { ToasterService } from "src/app/core/services/toastr.service";

@Component({
  selector: "megastore-header",
  standalone: true,
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  imports: [
    CommonModule,
    MatMenuModule,
    RouterModule,
    TranslateModule,
    SearchModule,
    MatDialogModule,
    MatSelectModule,
    NoDataFoundComponent,
    PipesModule,
    MatTooltipModule,
  ],
})
export class HeaderComponent implements OnDestroy {
  assetsConst = assetsConst;
  myDetailsDropDown = myDetailsDropDown;
  fetchUserName = fetchUserName;
  randomString = generateRandomString(10);
  isSignedIn = false;
  showDropDown = false;
  profileDetails: ProfileDetails | null = null;
  homeData: HomeData | null = null;
  subCategoryData: Array<Categories> = [];
  subscriptionSubject$!: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();
  selectedLanguage: string | null = "ar";
  wishListCount: number | null = null;
  bagListCount: number | null = null;
  search = "";
  selectedCategory: Categories | null = null;
  private platFormId = inject(PLATFORM_ID);
  searchDropDown = false;
  searchedData: globalSearchResponse | null = null;
  GlobalSearchType = GlobalSearchType;
  recentSearchedData: globalSearchResponse | null = null;
  isRecentAllowed = false;
  active_Mobile = false;
  currentAddress: string | null = null;
  isCmsPage = false;
  addressList: AddressPayload[] = [];
  selectedAddress: AddressPayload | null = null;
  isCheckoutPage: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _authService: AuthService,
    private _homeService: HomeService,
    private dialog: MatDialog,
    private router: Router,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private _logoutAlert: SwalAlertService,
    private _encryptionService: EncryptionService,
    private _translateService: TranslateService,
    private _bagService: BagService,
    private _toasterService: ToasterService
  ) {
    if (isPlatformBrowser(this.platFormId)) {
      const language = localStorage.getItem(environment.selectedLang);

      this.currentAddress = JSON.stringify(
        localStorage.getItem(environment.currentAddress)
      );

      if (!language)
        localStorage.setItem(
          environment.selectedLang,
          this.selectedLanguage ? this.selectedLanguage : "ar"
        );

      this._authService.selectedLang.subscribe((res: string | null) => {
        this.selectedLanguage =
          res || localStorage.getItem(environment.selectedLang); // Use local storage if no value from observable
        this.updateEmbeddedBodyClass(); // Update CSS class based on language
      });

      this.subscriptionSubject$ = this._authService.bagListCount
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: number | null) => {
          this.bagListCount = res;
        });

      this.subscriptionSubject$ = this._authService.wishListCount
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: number | null) => {
          this.wishListCount = res;
        });

      this.subscriptionSubject$ = this._authService.loggedIn
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: boolean) => {
          // if (res) this.getHomeData();
        });

      this.subscriptionSubject$ = this._authService.classMobile
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: boolean) => {
          this.active_Mobile = res;
        });

      this._authService.homeReload.subscribe((res: boolean) => {
        if (res && localStorage.getItem("reloadStatus") === "1") {
          window.location.reload();
          localStorage.setItem("reloadStatus", "2");
        }
      });

      this.subscriptionSubject$ = this._authService.routeToHomeData
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: boolean) => {
          // if (res) this.getHomeData();
        });

      this.subscriptionSubject$ = this._authService.addressList
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: AddressPayload[] | null) => {
          this.addressList = res || [];
          if (this.addressList.length > 0) {
            this.currentAddress = this.addressList.find(address => address.defaultAddress)?.address || '';
          }
        });

      this.initialize();
    }
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: Event): void {
    if (isPlatformBrowser(this.platFormId)) {
      const targetElement = event.target as HTMLElement;
      const clickedInsideDropdown =
        this.elementRef.nativeElement.contains(targetElement);
      const clickedInsideTabBar = targetElement.closest(".cont_ainer.tab_bar");

      if (!clickedInsideDropdown && !clickedInsideTabBar) {
        this.searchDropDown = false;
        this.showDropDown = false; // Close the dropdown
      }
    }
  }

  private initialize(): void {
    if (!this.router.url.includes('cms/privacyPolicyUserInfo')) {
      this.subscribeToProfileDetails();
      // this.getHomeData();
      this.checkIfCmsPage();
      this.getAddressList();
      this.getCartCount();
      this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.checkIfCmsPage();
      });
    }
  }

  private getCartCount(): void {
    this._bagService.getDashboardCounts().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this._authService.bagListCount.next(response.cartCount);
        this._authService.wishListCount.next(response.wishlistCount);
      },
    });
  }

  private getAddressList(): void {
    this._bagService.getAddresslistData().pipe(takeUntil(this.destroy$)).subscribe((response: AddressPayload[]) => {
      this.addressList = response;
    });
  }

  private updateEmbeddedBodyClass(): void {
    if (this.selectedLanguage === "ar") {
      this.renderer.addClass(this.document.body, "arabic-language");
    } else {
      this.renderer.removeClass(this.document.body, "arabic-language");
    }
  }

  private checkIfCmsPage(): void {
    const currentUrl = this.router.url;
    this.isCmsPage = currentUrl.startsWith("/cms");
    this.isCheckoutPage = currentUrl.startsWith("/checkout");
  }

  private subscribeToProfileDetails(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ProfileDetails | null) => {
        console.log("res", res, isPlatformBrowser(this.platFormId));
        if (isPlatformBrowser(this.platFormId)) {
          const checkSession = sessionStorage.getItem(
            environment.guestTokenKey
          );
          if (res !== null) {
            this.isSignedIn = true;
            this.profileDetails = res;
          } else if (checkSession) {
            this.isSignedIn = false;
          } else if (!checkSession && res === null) {
            this.isSignedIn = true;
            this.getProfileDetails();
          }
        }
      });
  }

  getHomeData(): void {
    this._homeService
      .getHomeData()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: HomeData) => {
          this._homeService.shimmer.next(true);
          this.homeData = response;
          this._authService.bagListCount.next(response.cartCount);
          this._authService.wishListCount.next(response.wishlistCount);
          // this._homeService.homeData.next(this.homeData);
        },
      });
  }

  private getProfileDetails(): void {
    this._authService
      .getProfileDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: ProfileDetails) => {
          this.profileDetails = res;
          this._authService.profileDetails.next(res);
        },
      });
  }

  reloadCurrentRoute(
    selectedCategory: Categories,
    subCategory: Categories
  ): void {
    this.active_Mobile = false;
    this.showDropDown = false;

    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(["product-listing/v2"], {
        queryParams: {
          categoryId: selectedCategory._id,
          subCat: subCategory._id,
        },
      });
      if (isPlatformBrowser(this.platFormId)) {
        const selectedCat = JSON.stringify(selectedCategory);
        const encryptedBody =
          this._encryptionService.encryptionPayload(selectedCat);
        localStorage.setItem("selectedCat", JSON.stringify(encryptedBody));
      }
    });
  }

  routeToProductList(
    category: Categories | Brands | Products,
    type: number
  ): void {
    this.fetchSearchOutput(null);

    switch (type) {
      case GlobalSearchType.BRAND:
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => {
            this.router.navigate(["/product-listing/v2"], {
              queryParams: {
                categoryType:'brand',
                id: category._id,
                productType: ProductType.TOP_Brands,
                throughGlobalSearch: true,
              },
            });
          });
        if (isPlatformBrowser(this.platFormId)) {
          const selectedCat = JSON.stringify(category);
          const encryptedBody =
            this._encryptionService.encryptionPayload(selectedCat);
          localStorage.setItem("selectedCat", JSON.stringify(encryptedBody));
        }
        break;
      case GlobalSearchType.CATEGORY:
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => {
            this.router.navigate(["/product-listing/v2"], {
              queryParams: {
                categoryType:'category',
                id: category._id,
                throughGlobalSearch: true,
              },
            });
          });
        if (isPlatformBrowser(this.platFormId)) {
          const selectedCat = JSON.stringify(category);
          const encryptedBody =
            this._encryptionService.encryptionPayload(selectedCat);
          localStorage.setItem("selectedCat", JSON.stringify(encryptedBody));
        }
        break;

      case GlobalSearchType.PRODUCT:
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => {
            this.router.navigate(["/product-detail/v2"], {
              queryParams: {
                id: category._id,
                throughGlobalSearch: true,
              },
            });
          });
        break;
    }
  }

  triggerDropDown(category: Categories): void {
    this.showDropDown = true;
    this.selectedCategory = category;
  }
  openDropDown(category: Categories): void {
    this.selectedCategory = category;
  }
  falseDropDown(): void {
    this.showDropDown = false;
  }

  action(item: { title: string; url: string }): void {
    if (item.title === "logout" || item.title === "deleteAccount") {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this._logoutAlert.swalAlert(item.title).then((res: any) => {
        if (res.value && res.isConfirmed) {
          this.handleAccount(item.title);
        }
      });
    } else {
      this.router.navigateByUrl(item.url);
    }
  }

  private handleAccount(type: string): void {
    (type === "logout"
      ? this._authService.logout()
      : this._authService.deleteAccount()
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: logoutResponse) => {
          if (res.statusCode === responseStatus.SUCCESS) {
            if (isPlatformBrowser(this.platFormId)) {
              this.isSignedIn = false;
              type === "logout"
                ? localStorage.removeItem(environment.storageKey)
                : localStorage.clear();
              const availableInSession = sessionStorage.getItem(
                environment.guestTokenKey
              );

              if (!availableInSession) {
                sessionStorage.setItem(
                  environment.guestTokenKey,
                  this.randomString
                );
              }
            }
            this.router.navigateByUrl("/");
            // this.getHomeData();
          }
        },
      });
  }

  LoginModal(): void {
    this.dialog.open(LoginComponent, {
      panelClass: ["modall", "login_nodal"],
    });
  }

  onFocus(event: boolean): void {
    if (event) {
      this.recentSearch();
    }
  }

  recentSearch(): void {
    this.searchDropDown = true;
    this._homeService
      .recentSearch()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: globalSearchResponse) => {
          if (response) {
            this.isRecentAllowed = true;
            this.recentSearchedData = response;
          }
        },
      });
  }

  clearRecentSearch(): void {
    this.searchDropDown = true;
    this._homeService
      .deleteRecentSearch()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          if (this.recentSearchedData) {
            this.recentSearchedData.product =
              this.recentSearchedData.category =
              this.recentSearchedData.brand =
                [];
          }
        },
      });
  }

  globalSearch(search: string): void {
    const query = `?search=${search}`;
    this.isRecentAllowed = false;
    this.searchDropDown = true;
    this._homeService
      .globalearch(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: globalSearchResponse) => {
          if (response) {
            this.searchedData = response;
          }
        },
      });
  }

  routeToPath(type: string): void {
    if (this.isSignedIn) {
      this.router.navigateByUrl(type);
    } else {
      this.LoginModal();
    }
  }

  fetchSearchOutput(event: string | null): void {
    if (event && event !== null) {
      this.search = event;
      this.globalSearch(this.search);
    } else {
      this.searchDropDown = false;
      this.search = "";
      this.searchedData = null;
    }
  }

  selectedLang(event: MatSelectChange): void {
    if (isPlatformBrowser(this.platFormId)) {
      this.selectedLanguage = event.value;
      this._authService.selectedLang.next(event.value);
      localStorage.setItem(environment.selectedLang, event.value);

      // Update the translation service without page reload
      this._translateService.use(event.value);
    }
  }

  routing(): void {
    this.router.navigateByUrl("/");
    this._authService.routeToHomeData.next(true);
  }

  openAddressModal(event: Event): void {
    // open only if the user is signed in
    if (!this.isSignedIn) {
      this.LoginModal();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.dialog
      .open(ChangeAddressComponent, {
        width: "800px",
        data: {
          addresses: this.addressList,
          selectedAddress: this.selectedAddress,
          access: 'selectOnly'
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          if (result.action === "change") {
            console.log(result, 'result');
            this.selectedAddress = result.address;
            this.currentAddress = result.address?.address;
            localStorage.setItem(environment.currentAddress, this.currentAddress || "");
            localStorage.setItem('latitude', JSON.stringify(result.address?.latitude));
            localStorage.setItem('longitude', JSON.stringify(result.address?.longitude));
            this._bagService.markAddressAsDefault(result.address, () => {
              this._toasterService.successToastr(
                this._translateService.instant(
                  "Default address updated successfully"
                )
              );
              localStorage.setItem("reloadStatus", "1");
              if (localStorage.getItem(environment.currentAddress)) {
                this._authService.homeReload.next(true);
              }
            });
            
          } else if (result.action === "change-locally") {
            this.selectedAddress = result.address;
            this.currentAddress = result.address;
            localStorage.setItem(environment.currentAddress, this.currentAddress || "");
            localStorage.setItem('latitude', JSON.stringify(result?.latitude));
            localStorage.setItem('longitude', JSON.stringify(result?.longitude));
            window.location.reload();
          }
        }
      });
  }

  markAddressAsDefault(address: AddressPayload): void {
    const body: AddressPayload = {
      addressType: address.addressType,
      houseNo: address.houseNo,
      landMark: address.landMark,
      address: address.address,
      city: address.city,
      state: address.state,
      pincode: address.pincode,
      phoneNo: address.phoneNo,
      country: address.country,
      countryCode: address.countryCode,
      latitude: address.latitude,
      longitude: address.longitude,
      email: address.email,
      name: address.name,
      defaultAddress: true,
    };

    this._bagService
      .editAddress(body, address && address._id ? address._id : "")
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this._toasterService.successToastr(
            this._translateService.instant(
              "Default address updated successfully"
            )
          );
          localStorage.setItem("reloadStatus", "1");
          if (localStorage.getItem(environment.currentAddress)) {
            this._authService.homeReload.next(true);
          }
        },
        error: () => {
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
    this.subscriptionSubject$.unsubscribe();
  }
}
